import { render, staticRenderFns } from "./showDocuments.vue?vue&type=template&id=fd393948"
import script from "./showDocuments.vue?vue&type=script&lang=js"
export * from "./showDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports